import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMegaphone16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMegaphone16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.515 1.976A1 1 0 0 1 13 2.85v8.3a1 1 0 0 1-1.485.874L7.87 10H5.813v2.944a1 1 0 0 1-1 1H3.765a1 1 0 0 1-.977-.787l-.743-3.4A2 2 0 0 1 1 8V6a2 2 0 0 1 2-2h4.871zM8 9H7V5h1.13l.113-.063L12 2.85v8.3L8.243 9.063 8.13 9zM3 5h3v4H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m.121 5 .644 2.944h1.048V10zM15 5.1a.5.5 0 0 0-1 0v3.49a.5.5 0 0 0 1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMegaphone16);
